import Button from 'devextreme-react/button';
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useTitle } from '../../../../contexts/title';
import '../../../../css/dashboard.scss';
import { useGetStatistics } from '../../../../api/statistics';
import { useAuth } from '../../../../contexts/auth';
import { LoadPagePanel } from '../../../../components';
import { ActionRequiredCard } from '../../../common';
import { CompanyTypes, ProductLine } from '../../../../types/enums';
import { useGetCompany } from '../../../../api/company';

export default function DistributorDashboard() {
	const navigate = useNavigate();
	const pageTitle = useTitle();

	useEffect(() => {
		pageTitle.setTitle('Action Required Items');
	}, [pageTitle])

	const { user } = useAuth();
	const statistics = useGetStatistics(user?.companyId!, user?.userName!, user?.companyTypeId!);
	const company = useGetCompany(user?.companyId!);
	const deliveryFlow = !company.data?.productLines?.find(x => x.productLineCode === 'SamplesLiterature');

	const urlFolder = user?.companyTypeId === CompanyTypes.MFR ? "manufacturer" :
		user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER ? "service-provider" : "distributor";

	return (
		<>
			<div className='content-block dashboard'>
				<LoadPagePanel visible={statistics.isLoading || statistics.isFetching} />

				{!statistics.isLoading &&
					<div>
						<div className='dx-clearfix'>
							<Button
								type='default'
								text="View in Table"
								icon="Inscyth-Action-Required"
								className='view-in-table-button' onClick={() => navigate(`/${urlFolder}/action-required`)}>
							</Button>
						</div>
						<div className='dashboard-section no-header'>

							<div className='ar-buttons-container'>

								{
									!deliveryFlow &&
									<ActionRequiredCard
										text='Distributor to Validate Ship Date'
										statData={statistics.data}
										statID={340}
										url={`/${urlFolder}/action-required-orders/340`}
										showPending={false}
										showPendingPlaceholder={true}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past two business days.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than two business days ago.
												</div>
											</div>
										}
									/>
								}
								{
									!deliveryFlow &&
									<ActionRequiredCard
										text='Distributor to Enter Ship Date'
										statData={statistics.data}
										statID={350}
										url={`/${urlFolder}/action-required-orders/350`}
										showPending={true}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders with a "Validated Ship Date" in the past two business days and today.
												</div>
												<div className='ar-description-pending'>
													Pending Orders: Orders with a "Validated Ship Date" in the future or set as pending.
												</div>
												<div className='ar-description-pastdue'>
													Past Due orders: Orders with a "Validated Ship Date" more than two business days ago.
												</div>
											</div>
										}
									/>
								}

								{
									deliveryFlow &&
									<ActionRequiredCard
										text='Distributor to Validate Delivery Date'
										statData={statistics.data}
										statID={341}
										url={`/${urlFolder}/action-required-orders/341`}
										showPending={false}
										showPendingPlaceholder={true}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders received in the past two business days.
												</div>
												<div className='ar-description-pastdue'>
													Past Due Orders: Orders received more than two business days ago.
												</div>
											</div>
										}
									/>
								}
								{
									deliveryFlow &&
									<ActionRequiredCard
										text='Distributor to Enter Delivery Date'
										statData={statistics.data}
										statID={351}
										url={`/${urlFolder}/action-required-orders/351`}
										showPending={true}
										showPendingPlaceholder={true}
										description={
											<div className='ar-description'>
												<div className='ar-description-active'>
													Active Orders: Orders with a "Validated Delivery Date" in the past two business days and today.
												</div>
												<div className='ar-description-pending'>
													Pending Orders: Orders with a "Validated Delivery Date" in the future.
												</div>
												<div className='ar-description-pastdue'>
													Past Due orders: Orders with a "Validated Delivery Date" more than two business days ago.
												</div>
											</div>
										}
									/>
								}

								<ActionRequiredCard
									text='Distributor to Invoice'
									statData={statistics.data}
									statID={360}
									url={`/${urlFolder}/action-required-orders/360`}
									showPending={false}
									showPendingPlaceholder={true}
									description={
										<div className='ar-description'>
											<div className='ar-description-active'>
												Active Orders: Orders with a "Actual Ship Date" or "Delivered Date" in the past two business days and today.
											</div>
											<div className='ar-description-pastdue'>
												Past Due orders: Orders with a "Actual Ship Date" or "Delivered Date" more than two business days ago.
											</div>
										</div>
									}
								/>
								<ActionRequiredCard
									text='Distributor to Approve Cancellation'
									statData={statistics.data}
									statID={344}
									url={`/${urlFolder}/action-required-orders/344`}
									showPending={false}
									showPendingPlaceholder={true}
									description={
										<div className='ar-description'>
											<div className='ar-description-active'>
												Active Orders: Orders received in the past two business days.
											</div>
											<div className='ar-description-pastdue'>
												Past Due orders: Orders received more than two business days ago.
											</div>
										</div>
									}
								/>
							</div>
						</div>
					</div>
				}
			</div>
		</>)
}
